<template>
  <div>
    <Breadcrumbs title="Categories"/>
    <div class="container-fluid">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-md-3 search-input">
              <input
                id="searchTerm"
                type="text"
                v-model="filterFields.name"
                placeholder="Search"
                class="form-control"
                @keyup="search"
              >
              <div
                class="reset-search"
                v-if="filterFields.name"
                @click="resetSearch"
              >
                <feather type="x"></feather>
              </div>
            </div>
            <div class="col-md-2">
              <button class="btn btn-primary mr-3 h-100" @click="getCategories()">
                <i class="fa fa-filter"></i> &nbsp; Filter
              </button>
            </div>
            <div class="col-md-4">

            </div>
            <div class="col-md-3 d-flex align-items-center justify-content-end">
              <button class="btn btn-primary" @click="openModalCreate()">
                <i class="fa fa-plus"></i> &nbsp; New
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <Loading v-if="loadingTable" style="height: 300px" />
          <table v-else class="table b-table b-table-stacked-md">
            <thead>
              <tr>
                <th>Category</th>
                <th>Created At</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="categories.length === 0">
                <td colspan="4" class="text-center">No Records Found</td>
              </tr>
              <tr v-for="(category, i) in categories" :key="i" v-else>
                <td>{{ category.name }}</td>
                <td>{{ category.createdDate }}</td>
                <td>
                  <span class="badge badge-success" v-if="category.isActive">Active</span>
                  <span class="badge badge-danger" v-if="!category.isActive">Inactive</span>
                </td>
                <td class="trash-wrapper">
                  <div class="d-flex">
                    <button class="btn-sm btn-primary mr-2" v-b-tooltip.hover title="Edit Category"
                      @click="openModalEdit(category)">
                      <i class="fa fa-edit"></i>
                    </button>
                    <button class="btn-sm btn-danger btn-trash" v-b-tooltip.hover title="Delete Category"
                      @click="deleteCategory(category)"
                      v-if="category.isActive">
                      <i class="icon-trash"></i>
                    </button>
                    <button class="btn-sm btn-warning btn-trash" v-b-tooltip.hover title="Activate category"
                      @click="restoreCategory(category)"
                      v-if="!category.isActive">
                      <i class="fa fa-arrow-circle-o-left"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <b-modal ref="modal-category" title="Edit Category" hide-footer size="lg">
      <div class="row">
        <div class="col-md-12">
          <form @submit.prevent="handleSubmit">
            <div class="form-group">
              <label for="categoryFields-name">Name</label>
              <input type="text" v-model="categoryFields.name" id="categoryFields-name" name="name" class="form-control" required />
            </div>
            <div class="form-group">
              <label for="categoryFields-description">Description</label>
              <textarea v-model="categoryFields.description" rows="3" id="categoryFields-description" name="description" class="form-control"></textarea>
            </div>
            <div class="form-group">
              <button type="submit" class="btn btn-primary" :disabled="loadingSubmit">Save Changes</button>
            </div>
          </form>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment';
import Loading from "../components/loading";

export default {
  name: "categories",
  components: {Loading},
  data() {
    return {
      loadingTable: true,
      filterFields: {
        name: ''
      },
      categories: [],
      categoryFields: {
        id: 0,
        name: '',
        description: ''
      },
      loadingSubmit: false,
      submitAction: ''
    }
  },
  methods: {
    search(e) {
      if (e.keyCode === 13) {
        this.getCategories()
      }
    },
    resetSearch() {
      this.filterFields.name = ''
      this.getCategories()
    },
    openModalCreate() {
      this.$refs['modal-category'].show();

      this.categoryFields = {
        id: 0,
        name: '',
        description: ''
      };

      this.submitAction = 'create';
    },
    openModalEdit(category) {
      this.$refs['modal-category'].show();

      this.categoryFields = {
        id: category.id,
        name: category.name,
        description: category.description
      };

      this.submitAction = 'edit';
    },
    closeModal() {
      this.$refs['modal-category'].hide();
    },
    deleteCategory(category) {
      this.$swal({
        text:'Are you sure you want to do delete "' + category.name + '"?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor: '#4466f2',
        cancelButtonText: 'Cancel',
        cancelButtonColor: '#efefef',
        reverseButtons: true
      }).then((val) => {
        if (val.value) {
          this.handleDelete(category);
        }
      });
    },
    restoreCategory(category) {
      this.$swal({
        text:'Are you sure you want to do activate "' + category.name + '"?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        confirmButtonColor: '#4466f2',
        cancelButtonText: 'Cancel',
        cancelButtonColor: '#efefef',
        reverseButtons: true
      }).then((val) => {
        if (val.value) {
          this.handleActivate(category);
        }
      });
    },
    async getCategories() {
      this.loadingTable = true;
      this.categories = [];

      this.$store.dispatch('getCategories', this.filterFields)
      .then(async(val) => {
        if (val.data.result) {
          this.categories = val.data.result.map(record => {
            return {
              id: record.id,
              name: record.name,
              description: record.description,
              createdDate: moment(record.createdDate).format('MMM D, YYYY'),
              isActive: record.isActive,
            }
          });
        }

        this.loadingTable = false
      })
      .catch(() => {
        this.loadingTable = false;
      });
    },
    async handleSubmit() {
      if (this.submitAction == 'edit') {
        this.handleSubmitUpdate();
      }
      else {
        this.handleSubmitCreate();
      }
    },
    async handleSubmitCreate() {
      this.loadingSubmit = true;

      this.$store.dispatch('createCategory', this.categoryFields)
      .then(async() => {
        this.toaster('success', 'The Category was successfully Created');
        this.closeModal();
        this.getCategories();
        this.loadingSubmit = false;
      })
      .catch(async(val) => {
        const message = this.formatExceptionMessage(val);
        this.toaster('error', message);

        this.loadingSubmit = false;
      });
    },
    async handleSubmitUpdate() {
      this.loadingSubmit = true;

      this.$store.dispatch('updateCategory', this.categoryFields)
      .then(async() => {
        this.toaster('success', 'The Category was successfully Updated');
        this.closeModal();
        this.getCategories();
        this.loadingSubmit = false;
      })
      .catch(async(val) => {
        const message = this.formatExceptionMessage(val);
        this.toaster('error', message);

        this.loadingSubmit = false;
      });
    },
    async handleDelete(category) {
      this.loadingSubmit = true;

      this.$store.dispatch('deleteCategory', category)
      .then(async(val) => {
        if (val.data.statusCode && val.data.statusCode === 200) {
          this.toaster('success', val.data.message);
          this.getCategories();
        }
        else {
          this.toaster('error', val.data.result);
        }

        this.loadingSubmit = false;
      })
      .catch(async(val) => {
        const message = this.formatExceptionMessage(val);
        this.toaster('error', message);

        this.loadingSubmit = false;
      });
    },
    async handleActivate(category) {
      this.loadingSubmit = true;

      this.$store.dispatch('activateCategory', category)
          .then(async(val) => {
            if (val.data.statusCode && val.data.statusCode === 200) {
              this.toaster('success', val.data.message);
              this.getCategories();
            }
            else {
              this.toaster('error', val.data.result);
            }

            this.loadingSubmit = false;
          })
          .catch(async(val) => {
            const message = this.formatExceptionMessage(val);
            this.toaster('error', message);

            this.loadingSubmit = false;
          });
    },
    formatExceptionMessage(val) {
        const resp = val.response.data;
        return resp.responseException && resp.responseException.exceptionMessage ? resp.responseException.exceptionMessage : 'Please try again';
    },
    toaster(type, message) {
      this.$toasted.show(message, {
        theme: 'bubble',
        position: 'top-right',
        type: type,
        duration: 3000
      });
    }
  },
  mounted() {
    this.getCategories();
  }
}
</script>

<style scoped lang="scss">
.search-input {
  position: relative;

  .reset-search {
    position: absolute;
    top: 50%;
    right: 20px;
    transform: translateY(-50%);
    line-height: 1;
    color: #ff5370;
    cursor: pointer;
  }
}
</style>
